import { render } from "./BgyxMenuLeft.vue?vue&type=template&id=3c093f05"
import script from "./BgyxMenuLeft.vue?vue&type=script&lang=js"
export * from "./BgyxMenuLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__